module.exports = __webpack_public_path__ + "static/media/onfleet-logo-grey.18fa0fc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onfleet-logo-grey.svg
// module id = 1867
// module chunks = 1